<template>
  <div class="row">
    <template v-for="children in model.children" :key="children?.vars?.id">
      <div v-if="children.vars.line_break" class="col-12"></div>
      <div
        v-if="(!children.vars.attr || !children.vars.attr['data-form-sticky']) && !children.vars.hide"
        :class="
          'form-group ' +
          (children.vars.row_attr && children.vars.row_attr.class ? ' ' + children.vars.row_attr.class : '') +
          (children.vars.toggle_class ? ' d-none ' + children.vars.toggle_class.replaceAll('\\', '') : '') +
          (!isSwitchType(children) && !isCheckboxType(children) && !isRadioType(children)
            ? ' d-flex flex-column justify-content-end'
            : '')
        "
      >
        <ModelComponent
          :disableFocusAnimation="disableFocusAnimation"
          :isFiltered="isFiltered"
          :model="children"
          @ajaxTargetLoad="ajaxTargetLoad"
          @ajaxTargetTrig="ajaxTargetTrig"
          @update="update"
          @toggle="toggle"
          @input="input"
          @uploading="uploading"
          @uploaded="uploaded"
          @dateChanged="dateChanged"
          @resetInputs="resetInputs"
          @sortCollection="sortCollection"
          @resetFilter="resetFilter"
          @filter="filter"
          @draft="draft"
          @selected="selected"
          @addEditAction="addEditAction"
          @toggleTab="toggleTab"
          @selectTypeAction="selectTypeAction"
          @buttonAction="buttonAction"
          @conditionalChildren="conditionalChildren"
        />
      </div>
    </template>
  </div>
</template>

<script>
import ModelComponent from "@/components/form/ModelComponent.vue";
import { formManager } from "@/services/form/form-manager";

export default {
  name: "ModelChildrenComponent",
  components: { ModelComponent },
  data() {
    return {};
  },
  emits: [
    "input",
    "ajaxTargetLoad",
    "ajaxTargetTrig",
    "update",
    "toggle",
    "uploading",
    "uploaded",
    "dateChanged",
    "resetInputs",
    "draft",
    "selected",
    "sortCollection",
    "addEditAction",
    "filter",
    "toggleTab",
    "selectTypeAction",
    "buttonAction",
    "conditionalChildren",
  ],
  props: {
    model: {
      type: Object,
      required: true,
    },
    isFiltered: {
      type: Boolean,
      required: false,
      default: false,
    },
    disableFocusAnimation: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  mounted() {},
  methods: {
    isSwitchType(model) {
      return formManager.isSwitchType(model);
    },

    isCheckboxType(model) {
      return formManager.isCheckboxType(model);
    },

    isRadioType(model) {
      return formManager.isRadioType(model);
    },

    expand() {
      this.expanded = true;
    },

    draft(model) {
      this.$emit("draft", model);
    },

    selected(model) {
      this.$emit("selected", model);
    },

    update(payload) {
      this.$emit("update", payload);
    },

    dateChanged(model) {
      this.$emit("dateChanged", model);
    },

    input(value) {
      this.$emit("input", value);
    },

    toggle(model) {
      this.$emit("toggle", model);
    },

    ajaxTargetLoad(payload) {
      this.$emit("ajaxTargetLoad", payload);
    },

    ajaxTargetTrig(payload) {
      this.$emit("ajaxTargetTrig", payload);
    },

    uploading() {
      this.$emit("uploading");
    },

    uploaded(data) {
      this.$emit("uploaded", data);
    },

    sortCollection() {
      this.$emit("sortCollection");
    },

    resetInputs(payload) {
      this.$emit("resetInputs", payload);
    },

    filter(payload) {
      this.$emit("filter", payload);
    },

    resetFilter() {
      this.$emit("resetFilter");
    },

    addEditAction(payload) {
      this.$emit("addEditAction", payload);
    },

    toggleTab(payload) {
      this.$emit("toggleTab", payload);
    },

    buttonAction(payload) {
      this.$emit("buttonAction", payload);
    },

    selectTypeAction(payload) {
      this.$emit("selectTypeAction", payload);
    },

    conditionalChildren(payload) {
      this.$emit("conditionalChildren", payload);
    },
  },
};
</script>

<style lang="scss" scoped></style>
